import WithRoutePermission from "shared/components/HOC/WithRoutePermission";
import { MODULES, SCREENS, SUBMODULES } from "utils/constants";
import Configure from "./Configure";
import Create from "./Create";
import Delete from "./Delete";
import Detail from "./Detail";
import Edit from "./Edit";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.LIST.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.INSURANCE_PLAN]: SUBMODULES.ADMIN_LIST }}
        WrappedComponent={List}
      />
    ),
  },
  {
    path: SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.CREATE.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.INSURANCE_PLAN]: SUBMODULES.ADMIN_CREATE }}
        WrappedComponent={Create}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.DETAIL.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.INSURANCE_PLAN]: SUBMODULES.ADMIN_DETAIL }}
        WrappedComponent={Detail}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.EDIT.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.INSURANCE_PLAN]: SUBMODULES.ADMIN_EDIT }}
        WrappedComponent={Edit}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.CONFIGURE.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.INSURANCE_PLAN]: SUBMODULES.ADMIN_EDIT }}
        WrappedComponent={Configure}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.DELETE.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.INSURANCE_PLAN]: SUBMODULES.ADMIN_DELETE }}
        WrappedComponent={Delete}
      />
    ),
  },
];

export default routes;
